export const environment = {
  production: true,
  recaptchaKey: '6Ld2Hy0fAAAAACAE5f85Zbk1pkXEJtzLVL3G0ViK'
};
